import { Controller, useFormContext } from "react-hook-form";

import { classNames } from "helpers/commonHelpers";
import Radio from "components/v2/Radio/Radio";
import { useCostRecoveryFields } from "@RequestFormV2/sections/Organisation/hooks/useCostRecoveryFields";
import OrganisationDynamicField from "@RequestFormV2/sections/Organisation/components/ShipmentDetailsSection/OrganisationDynamicField";

export default function CostRecoveryFields() {
  const { control } = useFormContext();
  const {
    costRecoveryField,
    showCostRecovery,
    costRecoverySubFields,
    radioOptions,
    getSubFieldDropdownOptions,
    showSubFields,
  } = useCostRecoveryFields();

  if (!showCostRecovery || !costRecoveryField) return null;

  return (
    <div className="mt-3xl">
      {costRecoveryField.label && (
        <label className={classNames("rfv2-cost-recovery__label", { required: costRecoveryField.mandatory })}>
          {costRecoveryField.label}
        </label>
      )}
      <div className="width-fit">
        <Controller
          name="organizational.cost_recovery_required"
          control={control}
          rules={{}}
          render={({ field }) => (
            <Radio options={radioOptions} value={field.value} size="md" onChange={field.onChange} isInline />
          )}
        />
      </div>

      {showSubFields && costRecoverySubFields.length > 0 && (
        <div className="rfv2-two-column-grid mt-xl">
          {costRecoverySubFields.map((field) => (
            <OrganisationDynamicField
              key={field.field_id}
              field={field}
              getDropdownOptions={getSubFieldDropdownOptions}
              useInitialData
              unknownTypeBehavior="editable"
            />
          ))}
        </div>
      )}
    </div>
  );
}
